/**
 * Retorna a URL base do backend para arquivos est\u00e1ticos (imagens).
 * Em dev: http://localhost:3030
 * Em prod: usa VUE_APP_BASE_URL
 */
// export function getBackendBaseUrl() {
//   return (process.env.VUE_APP_BASE_URL || 'http://localhost:3030').replace(/\/+$/, '');
// }

/**
 * Monta a URL completa de uma imagem servida pelo backend.
 * @param {string} caminho - caminho relativo (ex: /img/images/ImagensB2B/...)
 * @returns {string}
 */
export function resolveImagemUrl(caminho) {
  if (!caminho || typeof caminho !== 'string') {
    return `/img/images/ImagensB2B/produto-sem-imagem.webp`;
  }

  // J\u00e1 \u00e9 URL absoluta (http/https)
  if (caminho.startsWith('http://') || caminho.startsWith('https://')) {
    return caminho;
  }

  // Caminho legado com ~/
  if (caminho.startsWith('~/')) {
    return `/img/images/${caminho.slice(2)}`;
  }

  // Caminho relativo come\u00e7ando com /img/
  if (caminho.startsWith('/img/')) {
    return `${caminho}`;
  }

  // Fallback: prefixar com backend base
  return `${caminho.startsWith('/') ? '' : '/'}${caminho}`;
}

export const IMAGEM_PADRAO = `/img/images/ImagensB2B/produto-sem-imagem.webp`;

export function imagemProduto(produto = {}) {
  const imagens = (Array.isArray(produto.imagens) ? produto.imagens : [])
    .filter(img => typeof img?.caminho === 'string' && img.caminho.trim()
      && !img.caminho.includes('produto-sem-imagem'));
  const principal = imagens.find(img => Number(img.imagemPrincipal) === 1);
  const selecionada = produto.item_img_princial || produto.item_imagem;
  const caminho = typeof selecionada === 'string' && selecionada.trim()
    && !selecionada.includes('produto-sem-imagem')
    ? selecionada : (principal?.caminho || imagens[0]?.caminho);
  return resolveImagemUrl(caminho);
}
